import i18next from 'i18next';
import { initReactI18next, I18nextProvider, withTranslation } from 'react-i18next';
import Backend from 'i18next-http-backend';

export const i18nextInit = () => {
  if (i18next.isInitialized) {
    return Promise.resolve(i18next);
  }

  return i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: localStorage.getItem('i18nextLng') !== null ? (localStorage.getItem('i18nextLng') as string) : 'al',
      fallbackLng: 'al',
      supportedLngs: ['al', 'en', 'it'],
      debug: false,
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        requestOptions: {
          cache: 'no-store',
        },
      },
      interpolation: {
        escapeValue: false,
      },
    });
};

export { i18next as default };
export { I18nextProvider as defaultI18nextProvider };
export { withTranslation as defaultI18nWithTranslation };
